/**
 * What the app says about the server's own state, as opposed to anything about
 * the user's data (#392, CAP-O26): today, only "busy".
 *
 * A FIFTH deck (CAP-O27), rather than more entries in `firstRun.ts`,
 * `catalog.ts`, `coach.ts` or `movement.ts`: each scopes itself by its own
 * docstring, and a sentence about the server being busy is none of first run,
 * catalog setup, the coach's chrome or movement patterns. Both clients show
 * these two sentences, so by the rule in CLAUDE.md's Language section they live
 * in a deck pair the script checks.
 *
 * Its iOS twin is `ios/GroundworkKit/Sources/GroundworkKit/StatusCopy.swift`
 * (`enum StatusCopy`), and `python3 scripts/check_copy_decks.py` compares the
 * two on every symbol they share. **A string added here belongs there too.**
 *
 * - `busyRetrying`: the quiet line on a surface that is still loading while the
 *   server has refused its request as busy twice (a 503 with `Retry-After`,
 *   #391) and the app is asking again by itself. It says what is happening and
 *   asks nothing of the reader: no counter, no button.
 * - `busyWrite`: a write that met a busy server. A write is never sent again on
 *   its own (a 503 can arrive after part of its work was done), so unlike the
 *   line above it hands the next move to the reader. It takes the place of
 *   "Save failed. Check your connection and retry." and its siblings, only for
 *   an error that carries the busy marker.
 *
 * Interface chrome, so English whatever the coach speaks. No em dashes
 * (PRODUCT.md:47).
 */
export const STATUS_COPY = {
  busyRetrying: 'Busy right now. Trying again.',
  busyWrite: 'Busy right now. Try again in a moment.',
} as const
